// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GalleryTeaser_wrapper__vA9eA","mainImageButton":"GalleryTeaser_mainImageButton___bsU3","mainImage":"GalleryTeaser_mainImage__fV3oe"};